import { FC } from 'react';
import { useDispatch } from 'react-redux';

import { LinkButton } from '@rikstv/play-common/src/components/linkButton/LinkButton';
import { ExternalChannel } from '@rikstv/play-common/src/forces/channels/channel.types';
import { externalServiceLaunched } from '@rikstv/play-common/src/forces/externalService/actions';
import { AppJumpIcon } from '@rikstv/play-common/src/icons';
import { getImagePackSet } from '@rikstv/play-common/src/utils/imagePack/imagePack.utils';
import type { FCC } from '@rikstv/play-common/src/utils/types/typeUtils';

import { AssetImage } from '../../assetImage/AssetImage';
import { Breakpoints } from '../../grid/breakpoints';
import { ImageOverlayWrapper } from '../../imageOverlays/ImageOverlayWrapper';
import { StackedProviderImage } from '../../providerImage/StackedProviderImage';

import styles from './ExternalChannelPoster.module.css';

export const ExternalChannelPoster: FC<{ channel: ExternalChannel; poster: string }> = ({ channel, poster }) => {
  const dispatch = useDispatch();

  return (
    <ChannelImageWrapper name={channel.name} logo={channel.originChannel.logoUrls.svgSquare} poster={poster}>
      <LinkButton
        to={channel.links.externalPlayback.webPlaybackUri}
        buttonStyle="primary"
        onClick={() => {
          dispatch(
            externalServiceLaunched({
              elementId: channel.tracking.elementId,
              elementName: channel.tracking.elementName,
              reportUrl: null,
              serviceId: channel.links.externalPlayback.providerId,
            })
          );
        }}>
        <AppJumpIcon iconSize={22} className={styles.appJumpIcon} />
        <span>Se direkte i {channel.links.externalPlayback.displayName}</span>
      </LinkButton>
    </ChannelImageWrapper>
  );
};

const ChannelImageWrapper: FCC<{ poster: string; name: string; logo: string }> = ({ children, poster, logo, name }) => {
  return (
    <div className={styles.buttonContainer}>
      <AssetImage
        className={styles.channelPoster}
        imageSet={getImagePackSet({
          url: poster,
          variations: [{ width: 800, breakpoint: Breakpoints.DEFAULT }],
        })}
        alt={name}
      />
      <ImageOverlayWrapper>
        <StackedProviderImage variants={[{ name, logo }]} width="10%" />
      </ImageOverlayWrapper>
      <ImageOverlayWrapper centerContent backdropStyle="gradient">
        {children}
      </ImageOverlayWrapper>
    </div>
  );
};
